import "@/App.css";
import "@/index.css";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

// Components
import ScrollToTop from "@/components/ui/ScrollToTop";

// Chatbot
import SquareTriggerChatbot from "@/chatbot/SquareTriggerChatbot";

// Pages
import HomePage from "@/pages/HomePage";
import BlogPage from "@/pages/BlogPage";
import ContactPage from "@/pages/ContactPage";
import NotFoundPage from "@/pages/NotFoundPage";
import GetStartedPage from "@/pages/GetStartedPage";
import SolutionsPage from "@/pages/SolutionsPage";
import RdspToolForFinancialAdvisorsPage from "@/pages/RdspToolForFinancialAdvisorsPage";
import CustomDashboardDevelopmentVancouverPage from "@/pages/CustomDashboardDevelopmentVancouverPage";

import BurnabyDigitalAgencyPage from "@/pages/locations/BurnabyDigitalAgencyPage";
import SurreyDigitalAgencyPage from "@/pages/locations/SurreyDigitalAgencyPage";
import RichmondDigitalAgencyPage from "@/pages/locations/RichmondDigitalAgencyPage";
import NorthVancouverDigitalAgencyPage from "@/pages/locations/NorthVancouverDigitalAgencyPage";
import CoquitlamDigitalAgencyPage from "@/pages/locations/CoquitlamDigitalAgencyPage";
import LangleyDigitalAgencyPage from "@/pages/locations/LangleyDigitalAgencyPage";

// Service Pages
import WebsiteDevelopmentPage from "@/pages/services/WebsiteDevelopmentPage";
import ServicePage from "@/pages/services/ServicePage";
import SeoServicesPage from "@/pages/services/SeoServicesPage";
import SocialMediaMarketingPage from "@/pages/services/SocialMediaMarketingPage";
// import UiUxDesignPage from "@/pages/services/UiUxDesignPage";
import MaintenanceSupportPage from "@/pages/services/MaintenanceSupportPage";
// import EcommerceSolutionsPage from "@/pages/services/EcommerceSolutionsPage";

// Portfolio Pages
import CaseStudiesPage from "@/pages/portfolio/CaseStudiesPage";
import GalleryPage from "@/pages/portfolio/GalleryPage";
import TestimonialsPage from "@/pages/portfolio/TestimonialsPage";
import WorkPage from "@/pages/portfolio/WorkPage";

// Company Pages
import AboutPage from "@/pages/company/AboutPage";
import ProcessPage from "@/pages/company/ProcessPage";
import ValuesPage from "@/pages/company/ValuesPage";
import CareersPage from "@/pages/company/CareersPage";

// Resources Pages
import FAQsPage from "@/pages/resources/FAQsPage";
import FreeResourcesPage from "@/pages/resources/FreeResourcesPage";
import NewsPage from "@/pages/resources/NewsPage";

function App() {
  const location = useLocation();

  const noIndexRoutes = [];

  const shouldNoIndex = noIndexRoutes.some(
    (p) => location.pathname === p || location.pathname === `${p}/`
  );

  return (
    <>
      {/* Global Robots Tag */}
      <Helmet>
        <meta
          name="robots"
          content={shouldNoIndex ? "noindex, nofollow" : "index, follow"}
        />
      </Helmet>

      <ScrollToTop />

      <Routes>
        {/* Main Pages */}
        <Route path="/" element={<HomePage />} />

        {/* Blog */}
        <Route path="/blogs" element={<BlogPage />} />
        <Route path="/blogs/:id" element={<BlogPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:id" element={<BlogPage />} />

        <Route path="/contact" element={<ContactPage />} />
        <Route path="/get-started" element={<GetStartedPage />} />
        <Route path="/solutions" element={<SolutionsPage />} />
        <Route path="/services" element={<SolutionsPage />} />

        {/* RDSP Tool Page */}
        <Route
          path="/rdsp-tool-for-financial-advisors"
          element={<RdspToolForFinancialAdvisorsPage />}
        />
        <Route
          path="/RDSP-tool-for-financial-advisors"
          element={<Navigate to="/rdsp-tool-for-financial-advisors" replace />}
        />

        {/* Dashboard Page */}
        <Route
          path="/custom-dashboard-development-vancouver"
          element={<CustomDashboardDevelopmentVancouverPage />}
        />

       {/* Old Local Pages */}
<Route
  path="/digital-agency-surrey"
  element={<Navigate to="/digital-marketing-agency-surrey" replace />}
/>

<Route
  path="/digital-agency-burnaby"
  element={<Navigate to="/digital-marketing-agency-burnaby" replace />}
/>

<Route
  path="/digital-agency-richmond"
  element={<Navigate to="/digital-marketing-agency-richmond" replace />}
/>

<Route
  path="/digital-agency-north-vancouver"
  element={<Navigate to="/top-digital-agency-in-north-vancouver" replace />}
/>

<Route
  path="/digital-agency-coquitlam"
  element={<Navigate to="/digital-marketing-agency-coquitlam" replace />}
/>

<Route
  path="/digital-agency-langley"
  element={<Navigate to="/digital-marketing-agency-langley" replace />}
/>

        {/* Current Local Pages */}
        <Route
          path="/digital-marketing-agency-surrey"
          element={<SurreyDigitalAgencyPage />}
        />
        <Route
          path="/digital-marketing-agency-burnaby"
          element={<BurnabyDigitalAgencyPage />}
        />
        <Route
          path="/digital-marketing-agency-richmond"
          element={<RichmondDigitalAgencyPage />}
        />
        <Route
          path="/top-digital-agency-in-north-vancouver"
          element={<NorthVancouverDigitalAgencyPage />}
        />
        <Route
          path="/digital-marketing-agency-coquitlam"
          element={<CoquitlamDigitalAgencyPage />}
        />
        <Route
          path="/digital-marketing-agency-langley"
          element={<LangleyDigitalAgencyPage />}
        />

        {/* Service Pages  */}
        <Route
          path="/services/website-development-services"
          element={<WebsiteDevelopmentPage />}
        />
        <Route
          path="/services/search-engine-optimization-services"
          element={<SeoServicesPage />}
        />
        <Route
          path="/services/social-media-management-services"
          element={<SocialMediaMarketingPage />}
        />
        <Route
          path="/services/website-maintenance-company"
          element={<MaintenanceSupportPage />}
        />

        {/* Service Pages  */}
        <Route
          path="/services/website-development"
          element={<Navigate to="/services/website-development-services" replace />}
        />
        <Route
          path="/services/seo-services"
          element={
            <Navigate to="/services/search-engine-optimization-services" replace />
          }
        />
        <Route
          path="/services/social-media-marketing"
          element={
            <Navigate to="/services/social-media-management-services" replace />
          }
        />
        <Route
          path="/services/social-media-management"
          element={
            <Navigate to="/services/social-media-management-services" replace />
          }
        />
        <Route
          path="/services/maintenance-support"
          element={
            <Navigate to="/services/website-maintenance-company" replace />
          }
        />

        {/* Custom Tool Creation */}
        <Route
          path="/services/custom-tool-creation"
          element={
            <Navigate to="/services/custom-application-development" replace />
          }
        />
        <Route
          path="/services/custom tool creation"
          element={
            <Navigate to="/services/custom-application-development" replace />
          }
        />
        <Route
          path="/services/custom%20tool%20creation"
          element={
            <Navigate to="/services/custom-application-development" replace />
          }
        />

        {/* Dynamic Service Page */}
        <Route path="/services/:serviceSlug" element={<ServicePage />} />

        {/* Portfolio Pages */}
        <Route path="/portfolio/case-studies" element={<CaseStudiesPage />} />
        <Route path="/portfolio/gallery" element={<GalleryPage />} />
        <Route path="/portfolio/testimonials" element={<TestimonialsPage />} />
        <Route path="/work" element={<WorkPage />} />

        {/* Company Pages */}
        <Route path="/about" element={<AboutPage />} />
        <Route path="/company/about" element={<AboutPage />} />
        <Route path="/company/process" element={<ProcessPage />} />
        <Route path="/company/values" element={<ValuesPage />} />
        <Route path="/company/careers" element={<CareersPage />} />

      {/* Resources Pages */}
<Route path="/resources" element={<NotFoundPage />} />
<Route path="/resources/" element={<NotFoundPage />} />

<Route path="/faqs" element={<FAQsPage />} />
<Route path="/resources-faqs" element={<FAQsPage />} />
<Route path="/resources/faqs" element={<FAQsPage />} />
<Route path="/resources/free" element={<FreeResourcesPage />} />
<Route path="/resources/news" element={<NewsPage />} />

        {/* Fallback */}
       <Route path="*" element={<NotFoundPage />} />
      </Routes>

      {/* Chatbot overlay on all pages */}
      {/* <SquareTriggerChatbot /> */}
    </>
  );
}

export default App;